module.exports = __webpack_public_path__ + "static/media/nodeguard.96cbaf4f.svg";